import { EventParticipationDto } from '../Types/EventT';
import { ajaxActions } from './AjaxActions';
import { ToastS } from './ToastS';

const BASE_URL = process.env.REACT_APP_EVENT_SERVICE_URL;

const getByEventId = async (eventId: string): Promise<EventParticipationDto[]> => {
  const res = await ajaxActions.get(`${BASE_URL}/eventParticipations/${eventId}`);
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return [];
};

const getByContactId = async (contactId: number, briefest?: boolean): Promise<EventParticipationDto[]> => {
  const query = briefest !== undefined ? `?briefest=${briefest}` : '';
  const res = await ajaxActions.get(`${BASE_URL}/eventParticipations/contact/${contactId}${query}`);
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return [];
};

const save = async (dto: Partial<EventParticipationDto>): Promise<EventParticipationDto | null> => {
  const res = await ajaxActions.post(`${BASE_URL}/eventParticipations`, dto);
  if (res.ok) {
    ToastS.success('persist.event.participation', 'Kontakt erfolgreich am Event gespeichert');
    return res.json();
  }
  ToastS.error('persist.event.participation', 'Kontakt konnte nicht zum Event gespeichert werden');
  return null;
};

const remove = async (dto: EventParticipationDto): Promise<boolean> => {
  const res = await ajaxActions.del(`${BASE_URL}/eventParticipations`, dto);
  if (res.ok) {
    return true;
  }
  ToastS.generalError();
  return false;
};

const removeAllForContact = async (contactId: number): Promise<boolean> => {
  const res = await ajaxActions.del(`${BASE_URL}/eventParticipations/contact/${contactId}`);
  if (res.ok) {
    return true;
  }
  ToastS.generalError();
  return false;
};

// eslint-disable-next-line import/prefer-default-export
export const EventParticipationS = {
  getByEventId,
  getByContactId,
  save,
  remove,
  removeAllForContact,
};
